import React, {useContext} from 'react'
import ReactPlayer from 'react-player'
import CommonBtn from '../../components/buttons/commonBtn'
import { StatusContext } from '../../contexts/Status.context';

const QuickGuide = () => {
  const {
    setPageStatus,
    setEngine,
  } = useContext(StatusContext);

  const handleBack = () => {
    setEngine("menu");
    setPageStatus("Menu");
  };

  return (
    <div className="block lg:w-[80%] xl:w-[60%] lg:mx-auto">
      <div className="lg:w-[100%]">
        <div className="relative pt-[56.25%]">
          <div className="absolute top-0 right-0 left-0 bottom-0 flex items-center">
            <ReactPlayer
              url={"https://youtu.be/OUs8-wBgWkM"}
              width="100%"
              height="100%"
            />
          </div>
        </div>
        <div className="text-center mt-8">
          <CommonBtn status={0} onClick={handleBack}>
            Back
          </CommonBtn>
        </div>
      </div>
    </div>
  )
}

export default QuickGuide